import React from "react";

import {
  Class,
  JSTypeOperator,
  ObjectTypes,
} from "../../../../GenericCoreGraph/ClassFramework/Class";
import SellerDetailForCustomerPageStyles from "../../../../../ScriptStyles/SellerDetailForCustomerPageStyles";
import TObject from "../../../../TagComponents/TObject";

import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {Avatar, Button} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import { Rating } from "@material-ui/lab";
import PersonIcon from "@material-ui/icons/Person";
import GroupIcon from "@material-ui/icons/Group";
import TBaseDialogModal from "../../../Utilities/TBaseDialogModal";
import CreateIcon from "@material-ui/icons/Create";
import DefaultTheme from "../../../../../Themes/DefaultTheme";
import TAvatar from "../../../Components/BasicComponent/TAvatar";
import classNames from "classnames";

var TCustomerComments = Class(
  TBaseDialogModal,
  {
    ObjectType: ObjectTypes.Get("TCustomerComments"),
    constructor: function (_Props) {
      TCustomerComments.BaseObject.constructor.call(this, _Props);
      this.state = {
        ...this.state,
        open: false,
        rating: null,
      };
      window.App.CustomerComments = this;
    },
    Destroy: function () {
      TCustomerComments.BaseObject.Destroy.call(this);
    },
    /*Params: _Rating*/
    HandleClickOpen: function (_ParamObject, _CallbackOnClose) {
      TCustomerComments.BaseObject.HandleClickOpen.call(this, _ParamObject, _CallbackOnClose);
      this.CallbackOnClose = _CallbackOnClose;
      this.setState({
        open: true,
        rating: _ParamObject.Rating,
      });
    },
    HandleClose: function () {
      this.setState({
        open: false,
      });
      if (JSTypeOperator.IsFunction(this.CallbackOnClose)) {
        var __Function = this.CallbackOnClose;
        this.CallbackOnClose = null;
        __Function();
      }
    },
    HandleGetSize: function () {
      return "sm";
    }
    ,
    render: function () {
      var __This = this;
      const { classes } = this.props;
      var __Rating = __This.state.rating;
      var __Params = TCustomerComments.BaseObject.render.call(this);
      if (!__Params.NeedRender) {
        return  null;
      }
      return (
        __Rating && this.HandleWrapModal(
          <div>
              <DialogTitle
                id="customized-dialog-title"
                onClose={this.HandleInnerClose}
                className={classes.dialogTitle}
              >
                <Grid container item wrap="nowrap" spacing={2} md={12}>
                  <Grid item md={4}>
                    <TAvatar
                      src={window.App.GlobalParams.SiteUrl +"/assets/img/profileimages/" + __Rating.ProfileImage}
                      size={72}
                      className={classNames(classes.commentAvatarDetail,"img-avatar" )}
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    style={{ marginBlock: "auto", textAlign: "left" }}
                  >
                    <Typography className={classes.commentUserName2}>
                      {__Rating.Name + " " + __Rating.Surname}
                    </Typography>
                  </Grid>
                </Grid>
              </DialogTitle>
              <DialogContent dividers>
                <div>
                  <Grid item xs={12} sm={12}>
                    {__Rating.CustomerComment && (
                      <Typography className={classes.commentText2}>
                        {__Rating.CustomerComment}
                      </Typography>
                    )}

                    <br />
                  </Grid>
                  <Grid container item wrap="nowrap" spacing={2} md={12}>
                    <Grid item md={6}>
                      <Typography
                        className={classes.lessonType}
                        style={{ textAlign: "left" }}
                      >
                        {__This.state.Language[__Rating.LessonCode]}
                      </Typography>
                      <Typography variant="body2" display="block" gutterBottom>
                        {__Rating.LessonType === 0 ? (
                          <PersonIcon
                            fontSize="small"
                            style={{ marginRight: "10px", color: DefaultTheme.palette.secondary.main }}
                          />
                        ) : (
                          <GroupIcon
                            fontSize="small"
                            style={{ marginRight: "10px", color: DefaultTheme.palette.action.main }}
                          />
                        )}
                        {__Rating.LessonType === 0
                          ? this.state.Language.Individual
                          : this.state.Language.Class}
                      </Typography>
                    </Grid>
                    <Grid item md={6}>
                      <Typography className={classes.commentDate}>
                        <Rating
                          name={__Rating.RatingID}
                          defaultValue={__Rating.CustomerRating}
                          readOnly={true}
                          size={"medium"}
                        />
                      </Typography>
                      <Typography className={classes.commentDate2}>
                        {__Rating.CreateDate}
                      </Typography>
                    </Grid>
                  </Grid>
                  <br />
                  <Divider variant={"fullWidth"} />
                  <br />
                  <Button
                    fullWidth={true}
                    autoFocus
                    variant="contained"
                    color="primary"
                    onClick={() => this.HandleClose()}
                  >
                    {__This.state.Language.Close}
                  </Button>
                </div>
              </DialogContent>
          </div>
        )
      );
    },
  },
  {}
);

export default withStyles(SellerDetailForCustomerPageStyles)(TCustomerComments);
